import { KEY_ICONS } from "./components";

export const EMPTY_KEY = {
	keyValue: "",
	keyPressed: false,
	keyFit: false,
	keyIcon: null,
	keyId: null,
};

export const CLEAR_KEY = {
	...EMPTY_KEY,
	keyIcon: KEY_ICONS.CLEAR,
	keyId: 11,
	keyValue: "Clear",
};

export const ENTER_KEY = {
	...EMPTY_KEY,
	keyIcon: KEY_ICONS.ENTER,
	keyId: 12,
	keyValue: "Submit",
};

export const BACKSPACE_KEY = {
	...EMPTY_KEY,
	keyId: 13,
	keyValue: "BACKSPACE",
};

// Maximum number of tries allowed per level, indexed by currentLevelIndex (0-based).
// Level 1 (starting): 5 tries, Level 2: 4 tries, Level 3: 3 tries, Level 4: 2 tries, Level 5 (last): 1 try.
export const MAX_TRIES_PER_LEVEL = [5, 4, 3, 2, 1];

// How long to let the tries-left wave animation play on the last "try
// used" triangle before revealing the solution and advancing to the next
// level. Keep in sync with LevelCounter.js's TRIES_WAVE_STAGGER_MS and the
// `.tries-wave` animation duration in LevelCounter.scss (last triangle's
// delay + its own animation time), plus a small buffer.
export const TRIES_LEFT_ANIMATION_DELAY_MS = 800;

export const MESSAGE_HOLD_MS = 2000;

export const PIRMYD_FEEDBACK_STATES = {
	CORRECT: "correct",
	WRONG: "wrong",
	REVEALED: "revealed",
};

export const PIRMYD_FEEDBACK_MESSAGES = {
	[PIRMYD_FEEDBACK_STATES.CORRECT]: "Correct!",
	[PIRMYD_FEEDBACK_STATES.WRONG]: "Not quite. Try again.",
	[PIRMYD_FEEDBACK_STATES.REVEALED]: "Out of tries. The word was:",
};

export const PIRMYD_FEEDBACK_ICONS = {
	[PIRMYD_FEEDBACK_STATES.CORRECT]: "/static/images/feedback-correct.svg",
	[PIRMYD_FEEDBACK_STATES.WRONG]: "/static/images/feedback-wrong.svg",
	[PIRMYD_FEEDBACK_STATES.REVEALED]: "/static/images/feedback-revealed.svg",
};

export const RESULT_HEADING_BY_LEVELS_MISSED = {
	0: "You Broke the Curse. <span class='subheading'> A perfect excavation. </span>",
	1: "So Close You Could Hear <br> The Capstone Move.",
	2: "The Curse Is Weakening",
	3: "The Sand Is Shifting in Your Favor.",
	4: "Every Dig Starts Somewhere.",
	5: "Dust Yourself Off <span class='subheading'> The pyramid isn't going anywhere. </span>",
};
